"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var checkout_billing_address_form_1 = require("./checkout_billing_address_form");
var credit_card_html_form_1 = require("./credit_card_html_form");
// if a user has no cards on file, we render this comp
var CheckoutNewCreditCardAndBillingAddressForm = function (props) {
    return (React.createElement("div", null,
        React.createElement("div", { className: "module" },
            React.createElement(credit_card_html_form_1.default, null)),
        React.createElement(checkout_billing_address_form_1.default, tslib_1.__assign({}, props))));
};
exports.default = CheckoutNewCreditCardAndBillingAddressForm;
//# sourceMappingURL=checkout_new_credit_card_and_billing_address_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/checkout_new_credit_card_and_billing_address_form.js
// module id = 8QB3
// module chunks = 20 21 22